import { Link } from "react-router-dom";
import { Mail } from "lucide-react";
import { Logo } from "./Logo";
import { CONTACT_EMAIL } from "@/lib/content";

export const Footer = () => (
  <footer data-testid="site-footer" className="relative overflow-hidden bg-[#0A0F1D] text-slate-300">
    <div className="mx-auto max-w-7xl px-5 pb-10 pt-20 sm:px-8">
      <div className="grid gap-12 md:grid-cols-12">
        <div className="md:col-span-5">
          <Logo dark />
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-slate-400">
            An independent studio building its own apps for the Apple App Store and Google Play, and occasionally the web.
          </p>
        </div>
        <div className="md:col-span-3">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-slate-400">Pages</p>
          <ul className="mt-5 space-y-3 text-sm">
            {[["/", "Home"], ["/portfolio", "Portfolio"], ["/about", "About Us"], ["/contact", "Contact"]].map(([to, l]) => (
              <li key={to}><Link to={to} data-testid={`footer-link-${l.toLowerCase().replace(" ", "-")}`} className="transition-colors hover:text-white">{l}</Link></li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-4">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-slate-400">Say hello</p>
          <a href={`mailto:${CONTACT_EMAIL}`} data-testid="footer-email-link" className="mt-5 inline-flex items-center gap-2 text-base font-medium text-white transition-colors hover:text-[#5b9dff]">
            <Mail className="h-4 w-4" /> {CONTACT_EMAIL}
          </a>
        </div>
      </div>
      <p aria-hidden="true" className="font-display pointer-events-none mt-16 select-none text-[22vw] font-extrabold leading-[0.8] tracking-tighter text-white/[0.04] md:text-[16vw]">ARIES</p>
      <div className="mt-6 flex flex-col justify-between gap-3 border-t border-white/10 pt-6 text-xs text-slate-400 sm:flex-row">
        <span>© {new Date().getFullYear()} Aries App Station Inc. All rights reserved.</span>
        <span>ariesappstation.com</span>
      </div>
    </div>
  </footer>
);
